// extracted by mini-css-extract-plugin
export default {"age":"Home_age__Q9RiR","subtitle":"Home_subtitle__3pAVv","homeDetails":"Home_homeDetails__kxTa1","homeDetailsContainer":"Home_homeDetailsContainer__7DJhL"};